<template>
  <div class="pageview">
    <el-form
      :model="queryParams"
      ref="queryForm"
      size="small"
      :inline="true"
      v-show="showSearch"
      label-width="120px"
    >
      <el-form-item label="名称" prop="name">
      <el-input v-model="queryParams.name" placeholder="请输入名称" learable @keyup.enter.native="handleQuery" />
      </el-form-item>
        <el-form-item label="内容" prop="content">
      <el-input v-model="queryParams.content" placeholder="请输入内容" learable @keyup.enter.native="handleQuery" />
      </el-form-item>
        <el-form-item label="类型" prop="type">
      <el-select
          v-model="queryParams.type"
          filterable
          placeholder="请选择类型"
        >
          <el-option
            v-for="(item, index) in typeList"
            :key="index"
            :label="item.type"
            :value="item.id"
          />
        </el-select>
      </el-form-item>
       <el-button
        type="primary"
        icon="el-icon-search"
        size="mini"
        @click="queryFun()"
        >查询</el-button
      >  
      <el-button icon="el-icon-refresh" size="mini" @click="resetQuery"
        >重置</el-button
      >
      <el-button
        type="primary"
        icon="el-icon-search"
        size="mini"
        @click="$refs.searchInfo.addCreateForm(platForm)"
        >图片搜索</el-button
      >
    
      <el-button
        type="primary"
        plain
        icon="el-icon-plus"
        size="mini"
        @click="$refs.addImageLibrary.addCreateForm(platForm, userName)"
        >新增</el-button
      >
      <!-- </el-form-item> -->
    </el-form>
    <template v-if="!searchShow">
      <el-table v-loading="loading" :data="dataList">
        <el-table-column label="图片名称" align="center" prop="name" />
        <el-table-column label="类型" align="center" prop="imageTypeList">
          <template slot-scope="scope">
            <span v-for="(item, index) in scope.row.imageTypeList" :key="index">
              {{ item.type }}
            </span>
          </template>
        </el-table-column>
        <el-table-column label="内容" align="center" prop="content" />
        <el-table-column prop="url" label="图片">
          <template slot-scope="scope">
            <image-preview
              v-if="scope.row.url != null"
              :src="scope.row.url"
              :width="36"
              :height="36"
            />
          </template>
        </el-table-column>
        <el-table-column label="创建人" align="center" prop="createUser" />
        <el-table-column
          label="操作"
          align="center"
          class-name="small-padding fixed-width"
          width="450"
        >
          <template slot-scope="scope">
              <el-button
              size="mini"
              type="text"
              @click="$refs.detailsInfo.addCreateForm(scope.row)"
              >详情</el-button
            >
            <el-button
              size="mini"
              type="text"
              icon="el-icon-delete"
              @click="$refs.addImageLibrary.showCreateForm(scope.row)"
              >修改</el-button
            >
            <el-button
              size="mini"
              type="text"
              icon="el-icon-delete"
              @click="handleDelete(scope.row)"
              >删除</el-button
            >
          </template>
        </el-table-column>
      </el-table>

      <pagination
        v-if="!searchShow"
        v-show="total > 0"
        :total="total"
        :page.sync="queryParams.pageNum"
        :limit.sync="queryParams.pageSize"
        @pagination="getList"
      />
    </template>
     <div class="faceDatabase" v-else>
      <div
        class="faceDatabase_box"
        v-for="(item, index) in dataList"
        :key="index"
       @click="$refs.detailsInfo.addCreateForm(item.list)"
      >
        <!-- <image-preview :src="item.url" :width="100" :height="100" /> -->
        <div class="faceDatabase_box_imgBox">
          <img :src="item.list.url" class="faceDatabase_box_img" alt="" />
        </div>
        <span class="faceDatabase_box_name">{{ item.list.name }}</span>
        <span class="faceDatabase_box_time">相似度：{{ item.score }}</span>
        <!-- <div class="faceDatabase_box_btnBox">
          <el-button
            size="mini"
            type="primary"
            round
            plain
            @click="$refs.addImageLibrary.showCreateForm(item)"
            >修改</el-button
          >
            <el-button
            size="mini"
            type="danger"
            round
            plain
            @click.stop="handleDelete(item)"
            >删除</el-button
          >
        </div> -->
        <!-- <span class="faceDatabase_box_content"></span> -->
      </div>
      <div class="faceDatabase_empty">
        <el-empty description="暂无内容" v-if="dataList.length == 0"></el-empty>
      </div>
    </div>
    <addImageLibrary ref="addImageLibrary" @ok="getList" />
    <searchInfo ref="searchInfo" @ok="searchFun" />
    <detailsInfo ref="detailsInfo" />
  </div>
</template>

<script>
import { imageLibraryList, imageLibraryDel } from "@/api/imageLibrary";
import addImageLibrary from "@/views/system/imageLibrary/addImageLibrary";
import searchInfo from "@/views/system/imageLibrary/searchInfo";
import detailsInfo from "@/views/system/imageLibrary/detailsInfo";
import { imageTypeList } from "@/api/imageType";
import "@/assets/imgList.css";
export default {
  components: {
    addImageLibrary,
    searchInfo,
    detailsInfo
  },
  data() {
    return {
      queryParams: {
        pageNum: 1,
        pageSize: 10,
        platForm: "luoshanxian",
        // type: null
      },
      loading: false,
      total: 0,
      dataList: [],
      showSearch: true,
      platForm: "",
      userName: "",
      userId:'',
      oriApi:'',
      searchShow: false,
      typeList: [],
    };
  },
  created() {},
  mounted() {
   
    this.userId = this.$route.query.userId
    this.userName = this.$route.query.userName
    this.platForm = this.$route.query.platForm
    this.oriApi = this.$route.query.oriApi
    this.queryParams.platForm = this.platForm
    this.getList();
    this.getTypeList();
  },
  methods: {
    getList() {
      this.searchShow = false;
      imageLibraryList(this.queryParams).then((response) => {
        const result = response.data.data;
        console.log(result);
        this.dataList = result.list;
        this.total = result.total;
      });
    },
    queryFun() {
      this.queryParams.pageNum = 1;
      this.getList();
    },
      getTypeList() {
      imageTypeList({
        pageNum: 1,
        pageSize: 1000,
        platForm: this.platForm,
      }).then((response) => {
        const result = response.data.data;
        console.log(result);
        this.typeList = result.list;
      });
    },
    searchFun(list) {
        console.log(list)
      this.searchShow = true;
      this.dataList = list;
    },
    handleDelete(row) {
      const ids = row.id;
      this.$modal
        .confirm('是否确认删除编号为"' + ids + '"的数据项？')
        .then(function () {
          return imageLibraryDel({
            id: ids,
          });
        })
        .then(() => {
          this.getList();
          this.$modal.msgSuccess("删除成功");
        })
        .catch(() => {});
    },
    /** 搜索按钮操作 */
    handleQuery() {
      this.queryParams.pageNum = 1;
      this.getList();
    },
    /** 重置按钮操作 */
    resetQuery() {
      this.queryParams = {
        pageNum: 1,
        pageSize: 10,
        platForm: this.platForm,
      };
      this.handleQuery();
    },
  },
};
</script>
<style scoped>
.faceDatabase{
    margin-top: 20px;
}
</style>

